const Grades =  [
    {
        type:"Good",
        color:"#00B828",
        lowerRange: 106,
        upperRange: 160
    },{
        type:"Average",
        color:"#FFD700",
        lowerRange: 52,
        upperRange: 105
    },{
        type:"Poor",
        color:"#FF0000",
        lowerRange: 0,
        upperRange: 51
    }
]


export function getGrade(score){
    if(score >= 106){
        return Grades[0]
    }else if(score >= 52){
        return Grades[1]
    }else{
        return Grades[2]
    }
}

export default Grades